import React, { useEffect } from 'react';

const YELLOW = '#FFED29';
const BLACK = '#1a1a1a';
const DARK_GRAY = '#2d2d2d';
const WHITE = '#ffffff';
const BEIGE = '#f5f1e8';

const Leistungen = () => {
  // ---- TikTok Pixel Code ----
  useEffect(() => {
    // Check if TikTok pixel is already loaded
    if (window.ttq) return;

    const t = 'ttq';
    window.TiktokAnalyticsObject = t;
    const ttq = window[t] = window[t] || [];
    
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
    
    ttq.setAndDefer = function (target, method) {
      target[method] = function () {
        target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    
    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }
    
    ttq.instance = function (id) {
      const instance = ttq._i[id] || [];
      for (let n = 0; n < ttq.methods.length; n++) {
        ttq.setAndDefer(instance, ttq.methods[n]);
      }
      return instance;
    };
    
    ttq.load = function (pixelId, options) {
      const scriptUrl = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {};
      ttq._i[pixelId] = [];
      ttq._i[pixelId]._u = scriptUrl;
      ttq._t = ttq._t || {};
      ttq._t[pixelId] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[pixelId] = options || {};
      
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = scriptUrl + "?sdkid=" + pixelId + "&lib=" + t;
      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    };

    ttq.load('D4E3333C77UF4SPAJ6OG');
    ttq.page();
  }, []);

  const hourlyRates = [
    { name: 'Montageplatz', price: '15,00 €/h' },
    { name: 'Arbeitplatz', price: '15,00 €/h' },
    { name: 'Hebebühne', price: '17,00 €/h', },
    { name: 'Grube', price: '17,00 €/h',  },
    { name: 'Schweißgerät', price: '26,00 €/h',  },
    { name: 'Hydraulischer Wagenheber', price: '12,00 €/h' },
    { name: 'Bohrmaschine', price: '12,00 €/h' },
    { name: 'Stichsäge', price: '14,00 €/h' },
    { name: 'Heißluftgebläse', price: '12,00 €/h' },
    { name: 'Ausbeulen Gerät', price: '50,00 €/h' },
    { name: 'Mitgebrachte E-Werkzeuge', price: '3,00 €/h' }
  ];

  const flatRates = [
    { name: 'Kleinwerkzeuge', price: '1,00 € / Stück' },
    { name: 'Drehmomentschlüssel', price: '4,00 €' },
    { name: 'Federspanner', price: '15,00 €' },
    { name: 'Abzieher', price: '8,00 €' },
    { name: 'Kupplung-Zentrierdorn', price: '7,00 €' },
    { name: 'Achssatz', price: '6,00 €' },
    { name: 'Montagelampe', price: '3,00 €' },
    { name: 'Radlagerabzieher', price: '18,00 €' },
    { name: 'Nachteinlagerung in der Halle (20:00–8:00)', price: '15,00 €' }
  ];

  const disposalFees = [
    { name: 'Kühlflüssigkeit', price: '7,00 €' },
    { name: 'Bremsflüssigkeit', price: '6,00 €' },
    { name: 'Altöl', price: '6,00 €' },
    { name: 'Ölfilter', price: '4,00 €' },
    { name: 'Schalldämpfer', price: '8,00 €' },
    { name: 'Bremsklötze', price: '4,00 €' },
    { name: 'Bremscheiben', price: '4,00 €' },
    { name: 'Stoßdämpfer', price: '6,00 €' },
    { name: 'Altmetalle', price: '5,00 €' }
  ];

  const additionalServices = [
    { name: 'Zulassungsdienst', price: '150,00 €' },
    { name: 'Innen und Außen Aufbereitung', price: '60,00 €' }
  ];

  const oilPrices = [
    { type: '10W-40', desc: 'Teilsynthetisch', price: '9,99 €/Liter' },
    { type: '5W-40', desc: 'Vollsynthetisch', price: '11,99 €/Liter' },
    { type: '5W-30', desc: 'Longlife', price: '14,99 €/Liter' }
  ];

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif;
        }
        
        @media (max-width: 968px) {
          .services-grid { grid-template-columns: 1fr !important; }
          .oil-grid { grid-template-columns: 1fr !important; }
          .two-col-grid { grid-template-columns: 1fr !important; }
          .additional-services-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <div style={{
        backgroundColor: WHITE,
        minHeight: '100vh'
      }}>
        
        {/* Hero Section */}
        <div style={{
          position: 'relative',
          padding: '150px 40px',
          textAlign: 'center',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/garage (1)/garage/11.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 1
          }} />
          
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.6))',
            zIndex: 2
          }} />
          
          <div style={{
            position: 'relative',
            zIndex: 3
          }}>
            <h1 style={{
              fontSize: '3.5rem',
              fontWeight: 900,
              color: WHITE,
              marginBottom: '20px',
              letterSpacing: '-1px',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
            }}>
              Unsere Leistungen & <span style={{ color: YELLOW }}>Preise</span>
            </h1>
            <p style={{
              fontSize: '1.2rem',
              color: WHITE,
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: 1.6,
              textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
            }}>
              Faire Preise für alle, die selbst anpacken wollen.
            </p>
          </div>
        </div>

        {/* Category 1 - Hourly Rates */}
        <section style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '80px 40px',
          backgroundColor: WHITE
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: BLACK,
            marginBottom: '30px',
            letterSpacing: '-0.5px'
          }}>
            Stundenpreise
          </h2>
          
          <div className="services-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '20px',
            marginBottom: '30px'
          }}>
            {hourlyRates.map((item, i) => (
              <div key={i} style={{
                backgroundColor: '#f8f8f8',
                padding: '25px 20px',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                borderLeft: `4px solid ${YELLOW}`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.transform = 'translateX(5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f8f8f8';
                e.currentTarget.style.transform = 'translateX(0)';
              }}>
                <h3 style={{
                  fontSize: '1.05rem',
                  color: BLACK,
                  marginBottom: '12px',
                  fontWeight: 600
                }}>{item.name}</h3>
                <div style={{
                  fontSize: '1.4rem',
                  color: BLACK,
                  fontWeight: 900,
                  marginBottom: item.note ? '8px' : '0'
                }}>{item.price}</div>
                {item.note && (
                  <div style={{
                    fontSize: '0.8rem',
                    color: '#666',
                    fontStyle: 'italic'
                  }}>{item.note}</div>
                )}
              </div>
            ))}
          </div>

          <div style={{
            fontSize: '0.9rem',
            color: '#666',
            fontStyle: 'italic',
            marginTop: '30px',
            padding: '20px',
            backgroundColor: BEIGE,
            borderLeft: `4px solid ${YELLOW}`
          }}>
            ⚠️ Die Reservierung einer Hebebühne ist nicht möglich. Letzter Fahrzeugeinlass: 1 h vor Ladenschluss.
          </div>
        </section>

        {/* Category 2 - Flat Rates */}
        <section style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '80px 40px',
          backgroundColor: BEIGE
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: BLACK,
            marginBottom: '15px',
            letterSpacing: '-0.5px'
          }}>
            Pauschalpreise
          </h2>
          <p style={{
            fontSize: '1rem',
            color: '#666',
            marginBottom: '30px'
          }}>
            Tagesmiete / einmaliges Ausleihen
          </p>

          <div className="two-col-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '15px'
          }}>
            {flatRates.map((item, i) => (
              <div key={i} style={{
                backgroundColor: WHITE,
                padding: '20px 25px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'all 0.3s ease',
                borderLeft: `4px solid ${YELLOW}`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f8f8f8';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = WHITE;
              }}>
                <span style={{
                  fontSize: '0.95rem',
                  color: BLACK,
                  fontWeight: 500
                }}>{item.name}</span>
                <span style={{
                  fontSize: '1.15rem',
                  color: BLACK,
                  fontWeight: 900
                }}>{item.price}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Category 3 - Disposal Fees */}
        <section style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '80px 40px',
          backgroundColor: WHITE
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: BLACK,
            marginBottom: '30px',
            letterSpacing: '-0.5px'
          }}>
            Entsorgungsgebühren
          </h2>

          <div style={{
            backgroundColor: '#f8f8f8',
            overflow: 'hidden'
          }}>
            {disposalFees.map((item, i) => (
              <div key={i} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '18px 25px',
                borderBottom: i < disposalFees.length - 1 ? `1px solid #ddd` : 'none',
                transition: 'background-color 0.3s ease',
                borderLeft: `4px solid ${YELLOW}`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}>
                <span style={{
                  fontSize: '0.95rem',
                  color: BLACK,
                  fontWeight: 500
                }}>{item.name}</span>
                <span style={{
                  fontSize: '1.15rem',
                  color: BLACK,
                  fontWeight: 900
                }}>{item.price}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Category 4 - Additional Services (NEW) */}
        <section style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '80px 40px',
          backgroundColor: BEIGE
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: BLACK,
            marginBottom: '30px',
            letterSpacing: '-0.5px'
          }}>
            Zusätzliche Dienstleistungen
          </h2>

          <div className="additional-services-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '20px'
          }}>
            {additionalServices.map((item, i) => (
              <div key={i} style={{
                backgroundColor: WHITE,
                padding: '35px 30px',
                transition: 'all 0.3s ease',
                borderLeft: `4px solid ${YELLOW}`,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f8f8f8';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = WHITE;
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <h3 style={{
                  fontSize: '1.1rem',
                  color: BLACK,
                  marginBottom: '15px',
                  fontWeight: 600
                }}>{item.name}</h3>
                <div style={{
                  fontSize: '1.8rem',
                  color: BLACK,
                  fontWeight: 900
                }}>{item.price}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Category 5 - Oil Prices */}
        <section style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '80px 40px',
          backgroundColor: WHITE
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: BLACK,
            marginBottom: '30px',
            letterSpacing: '-0.5px'
          }}>
            Ölpreise
          </h2>

          <div className="oil-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '20px'
          }}>
            {oilPrices.map((item, i) => (
              <div key={i} style={{
                backgroundColor: BEIGE,
                padding: '35px 25px',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                borderLeft: `4px solid ${YELLOW}`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0ebe0';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = BEIGE;
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <div style={{
                  fontSize: '1.8rem',
                  fontWeight: 900,
                  color: BLACK,
                  marginBottom: '8px'
                }}>{item.type}</div>
                <div style={{
                  fontSize: '0.9rem',
                  color: '#666',
                  marginBottom: '15px'
                }}>{item.desc}</div>
                <div style={{
                  fontSize: '1.6rem',
                  fontWeight: 900,
                  color: BLACK
                }}>{item.price}</div>
              </div>
            ))}
          </div>
        </section>

      </div>
    </>
  );
};

export default Leistungen;